<app-back-button></app-back-button>
<div class="header">
  <div class="instituicao-info">
    <div class="name-area">
      <div class="left-area">
        <div class="avatar">
          <p-avatar
            *ngIf="!imageError && imagePreview; else defaultAvatar"
            [image]="$any(imagePreview)"
            shape="circle"
            size="xlarge"
            (onImageError)="imageError = true"
          />
          <ng-template #defaultAvatar>
            <p-avatar
              [label]="getInitials(bolseiro?.nome)"
              [icon]="!bolseiro?.nome ? 'pi pi-user' : undefined"
              shape="circle"
              size="xlarge"
            />
          </ng-template>
        </div>
        <div class="title-header">
          <span class="name">{{bolseiro?.nome}}</span>
          <div class="info d-flex align-items-center flex-wrap gap-2">
            <span><strong>Nº BI: {{ bolseiro?.numeroBI }}</strong></span>
            <span>•</span>
            <span>
              <p-tag *ngIf="bolseiro?.isActive" severity="success" value="Activo" />
              <p-tag *ngIf="!bolseiro?.isActive" severity="danger" value="Inactivo" />
            </span>

            <!-- BADGES DE MATRÍCULA ATUAL (se houver) -->
            <!-- <ng-container *ngIf="matriculaAtual as m">
              <span>•</span>
              <p-chip *ngIf="currentAnoCurricular" label="Ano Curricular: {{ currentAnoCurricular }}"></p-chip>

              <span *ngIf="currentCurso">•</span>
              <p-chip *ngIf="currentCurso" label="Curso: {{ currentCurso }}"></p-chip>

              <span *ngIf="currentFase">•</span>
              <p-chip *ngIf="currentFase" label="Fase: {{ currentFase }}"></p-chip>

              <span *ngIf="currentUnidInst">•</span>
              <p-chip *ngIf="currentUnidInst" label="{{ currentUnidInst }}"></p-chip>
            </ng-container> -->
          </div>

        </div>
      </div>
    </div>
    <div class="align contact-info">
      <div class="phone">
        <div class="icon">
          <img src="icons/phone.svg" alt="Phone Icon" />
        </div>
        <span>{{ bolseiro?.contactoPrincipal }}</span>
      </div>
      <div class="email">
        <div class="icon">
          <img src="icons/email.svg" alt="Email Icon" />
        </div>
        <span>{{ bolseiro?.email }}</span>
      </div>
      <!-- <div class="site">
        <div class="icon">
          <img src="icons/globe-01.svg" alt="map Icon" />
        </div>
        <span>{{ bolseiro?.tipoBolsaID === 1 ? 'Parcial' : 'Integral' }}</span>
      </div> -->
      <div class="country">
        <div class="icon">
          <img src="icons/map-pin.svg" alt="Country Icon" />
        </div>
        <span>{{ bolseiro?.endereco }}</span> • Criado Por - <span>{{ bolseiro?.criadoPorNome }}</span>

      </div>
      <!-- <div class="country">
        <div class="icon">
          <img src="icons/graduation-grey.svg" alt="Country Icon" />
        </div>
        <span>{{ bolseiro?.internacional ? 'Externa' : 'Interna' }}</span>
      </div> -->
    </div>
  </div>
</div>
<ng-container *ngIf="matriculaAtual as m; else elseTemplate">
  <div class="matricula-card p-3 border-round surface-card shadow-1 mt-3">
    <div class="flex align-items-center gap-2 mb-2">
      <i class="pi pi-book text-primary"></i>
      <span class="title text-uppercase">Matrícula atual</span>
    </div>
    <div class="grid">
      <div class="col-12 md:col-3">
        <small class="block text-600 text-uppercase">Instituição - Unid. Orgânica</small>
        <div class="font-semibold text-uppercase">{{ currentUnidInst || '—' }}</div>
      </div>
      <div class="col-12 md:col-3">
        <small class="block text-600 text-uppercase">Fase</small>
        <div class="text-xl font-semibold text-uppercase">{{ currentFase || '—' }}</div>
      </div>
      <div class="col-12 md:col-3">
        <small class="block text-600 text-uppercase">Curso</small>
        <div class="text-xl font-semibold text-uppercase">{{ currentCurso || '—' }}</div>
      </div>
      <div class="col-12 md:col-3">
        <small class="block text-600 text-uppercase">Ano Curricular</small>
        <div class="text-xl font-semibold text-uppercase">{{ currentAnoCurricular || '—' }}</div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #elseTemplate>
  <div class="matricula-card p-3 border-round surface-card shadow-1 mt-3">
    <div class="grid">
      <div class="col-12">
        <div class="text-xl font-semibold">SEM MATRÍCULA ATUAL</div>
      </div>
    </div>
  </div>
</ng-template>



<div class="actions">
  <p-button label="Editar Estudante" icon="pi pi-pen-to-square" iconPos="left" severity="secondary"
    (click)="GotoAddBolseiro()" />
  <!-- <p-button label="Desactivar Estudante" [label]="bolseiro?.isActive ? 'Desactivar Estudante' : 'Activar Estudante'" [icon]="bolseiro?.isActive ? 'pi pi-ban' : 'pi pi-check-circle'" iconPos="right" severity="secondary" (click)="toggleBolseiroStatus()"/> -->
  <p-button label="Mais Detalhes do Estudante" icon="pi pi-info-circle" iconPos="right" severity="secondary"
    (click)="clickMaisDetalhe(bolseiro)" />
</div>
<p-tabs value="0">
  <p-tablist>
    <p-tab value="0">
      <div class="tab-icon">
        <img src="icons/users-check.svg" alt="user Icon" />
      </div>
      Auxílios de Formações Vinculados
    </p-tab>
    <p-tab value="1">
      <div class="tab-icon">
        <img src="icons/dollar.svg" alt="Dollar Icon" />
      </div>
      Dados Financeiros
    </p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      <div class="list">
        <div *ngIf="filters; else noDataTemplate">
          <app-listar-bolsa-bolseiros [bolseiro]="bolseiro" [bolseiroID]="bolseiroID"></app-listar-bolsa-bolseiros>
        </div>
        <ng-template #noDataTemplate>
          <div class="no-data">
            <p>Nenhuma instituição de ensino encontrada.</p>
          </div>
        </ng-template>

      </div>
    </p-tabpanel>
    <p-tabpanel value="1">
      <div class="list">
        <div>
          <app-lista-dado-financeiro [bolseiroID]="bolseiroID"></app-lista-dado-financeiro>
        </div>
      </div>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>



<p-toast></p-toast>
<p-confirmdialog>
  <ng-template #message let-message>
    <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
      <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmdialog>

<p-drawer [(visible)]="showDetalhe" position="right" [style]="{'width': '720px'}"
  styleClass="!w-full md:!w-80 lg:!w-[30rem]">
  <ng-template #headless>
    @if (maisDetalheEstudante) {
    <app-mais-detalhe-estudante [estudanteSelected]="maisDetalheEstudante"
      (onCloseModal)="showDetalhe=false"></app-mais-detalhe-estudante>
    <!--<app-mais-detalhe-vaga [vagaSelected]="maisDetalheVagas" (onCloseModal)="showDetalhe=false"></app-mais-detalhe-vaga>-->
    }
  </ng-template>
</p-drawer>


<!--
<div class="contents">
  <app-back-button></app-back-button>
  <div class="header">
    <div class="bolseiro-info">
      <div class="name-area">
        <div class="left-area">
          <span class="name">{{ bolseiro?.nome }}</span>
          <div class="info">
            <span>Contato Principal: <strong>{{ bolseiro?.contatoPrincipal }}</strong></span>
            <span>•</span>
            <span>Nome da Mãe: <strong>{{ bolseiro?.nomeMae }}</strong></span>
            <span>•</span>
            <span>Nome do Pai: <strong>{{ bolseiro?.nomePai }}</strong></span>
            <span>•</span>
            <span>Endereço: <strong>{{ bolseiro?.endereco }}</strong></span>
            <span>•</span>
            <span>Número do BI: <strong>{{ bolseiro?.numeroBI }}</strong></span>
            <span>•</span>
            <span>Nível Académico: <strong>{{ bolseiro?.nivelAcademico }}</strong></span>
            <span>•</span>
            <p-tag [severity]="bolseiro?.isActive ? 'success' : 'danger'"
              [value]="bolseiro?.isActive ? 'Activo' : 'Inactivo'"></p-tag>
            <span>•</span>
            <span>{{ bolseiro?.vagas }} vagas</span>
            <span>•</span> --
            -- <span><span class="status">{{ bolseiro?.isActive ? 'Activa' : 'Inactiva' }}</span></span>
          </div>
        </div>
      </div>
      <div class="contact-info">
        -- <div class="phone">
          <div class="icon">
            <img src="icons/phone.svg" alt="Phone Icon" />
          </div>
          <span>{{ bolseiro?.anoLectivoInicio }} à {{ bolseiro?.anoLectivoFim }}</span>
        </div> -->
<!-- <div class="email">
          <div class="icon">
            <img src="icons/award-01.svg" alt="Email Icon" />
          </div>
          <span>{{ bolseiro?.tipoBolsa?.designacao }}</span>
        </div>
        <div class="email">
          <div class="icon">
            <img src="icons/email.svg" alt="Email Icon" />
          </div>
          <span>{{ bolseiro?.email }}</span>
        </div>
        <div class="email">
          <div class="icon">
            <img src="icons/phone.svg" alt="Email Icon" />
          </div>
          <span>{{ bolseiro?.contactoPrincipal }}</span>
        </div>
        <div class="email">
          <div class="icon">
            <img src="icons/graduation-grey.svg" alt="Email Icon" />
          </div>
          <span>{{ bolseiro?.numeroBI }}</span>
        </div>
        <-- <div class="email">
          <div class="icon">
            <img src="icons/graduation-grey.svg" alt="Email Icon" />
          </div>
          <span>{{ bolseiro?.nivelAcademico }}</span>
        </div> --
        <div class="email">
          <div class="icon">
            <img src="icons/coins-hand.svg" alt="Email Icon" />
          </div>
          <span>{{ bolseiro?.tipoBolsaID === 1 ? 'Parcial' : 'Integral' }}</span>
        </div>
        <div class="country">
          <div class="icon">
            <img src="icons/globe.svg" alt="Country Icon" />
          </div>
          <span>{{ bolseiro?.internacional ? 'Internacional' : 'Interna' }}</span>
        </div>
      </div>
    </div>
    <div class="info">

    </div>
    -- <div class="indicator">
      <div class="avatars">
        <img *ngFor="let person of participants" [src]="person.photo" alt="participant" />
      </div>
      <div class="text">
        <span>{{ bolseiro?.bolseiros?.length || 0 }} Estudantes</span>
      </div>
    </div> --
  </div>
  <div class="actions">
    <p-button severity="secondary" [text]="true" (click)="GotoAddBolseiro()">
      <img src="icons/edit-05.svg" alt="Email Icon" />
      Editar Estudante
    </p-button>
    <-- <p-button severity="primary" (onClick)="showDialog()">
      Vincular estudante
      <img src="icons/user-right-01.svg" alt="Email Icon" />
    </p-button> --
    <p-button severity="secondary" (click)="visibleDetails = true">
      Mais Detalhes do Estudante
      <img src="icons/user-right-01.svg" alt="Email Icon" />
    </p-button>
    <p-button [label]="bolseiro?.isActive ? 'Desactivar Estudante' : 'Activar Estudante'" icon="pi pi-info-circle"
      iconPos="right" severity="danger" (click)="toggleBolseiroStatus()" />
  </div>
  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0">
        <div class="tab-icon">
          <img src="icons/users-check.svg" alt="Email Icon" />
        </div>
        Auxílios de Formação Vinculados
      </p-tab>
      <-- <p-tab value="1">
        <div class="tab-icon">
          <img src="icons/building-05.svg" alt="Email Icon" />
        </div>
        Instituições
      </p-tab> --
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <app-listar-bolsa-bolseiros [bolseiro]="bolseiro" [bolseiroID]="bolseiroID"></app-listar-bolsa-bolseiros>
      </p-tabpanel>
      <-- <p-tabpanel value="1"> --
      <-- <app-listar-instituicoes-ensino-bolseiro [bolseiroID]="bolseiroID"></app-listar-instituicoes-ensino-bolseiro> --
      <-- </p-tabpanel> --
    </p-tabpanels>
  </p-tabs>
  <p-toast></p-toast>
</div>

<p-drawer header="Perfil do profissional" [(visible)]="visibleDetails" position="right" [style]="{'width': '40vw'}">
  <div class="profile-header">
    <p-avatar
      *ngIf="!imageError && imagePreview; else defaultProfileAvatar"
      [image]="$any(imagePreview)"
      shape="circle"
      size="xlarge"
      (onImageError)="imageError = true"
    />
    <ng-template #defaultProfileAvatar>
      <p-avatar
        [label]="getInitials(bolseiro?.nome)"
        [icon]="!bolseiro?.nome ? 'pi pi-user' : undefined"
        shape="circle"
        size="xlarge"
      />
    </ng-template>
    <div>
      <h2>{{ bolseiro?.nome }}</h2>
      <p>Engineer Technician &nbsp; • &nbsp;<span class="degree">{{ bolseiro?.nivelAcademicoDescricao }}</span></p>
    </div>
  </div>
  <p-divider></p-divider>

  <h3>Informações Pessoais</h3>
  <div class="info-grid">
    <div>
      <p class="icon-prof">
        <i class="pi pi-phone"></i>
      </p>
      <div class="descriction-prof">
        <span>Telefone</span>
        <p>{{ bolseiro?.contactoPrincipal }}</p>
      </div>
    </div>
    <div>
      <p class="icon-prof">
        <i class="pi pi-calendar"></i>
      </p>
      <div class="descriction-prof">
        <span>Data de Nascimento</span>
        <p>{{ bolseiro?.dataNascimento | date:'shortDate' }}</p>
      </div>
    </div>
    <div>
      <p class="icon-prof">
        <i class="pi pi-calendar"></i>
      </p>
      <div class="descriction-prof">
        <span>Estado Civil</span>
        <p>{{ bolseiro?.estadoCivil }}</p>
      </div>
    </div>
    <div>
      <p class="icon-prof">
        <i class="pi pi-calendar"></i>
      </p>
      <div class="descriction-prof">
        <span>Nacionalidade</span>
        <p>{{ bolseiro?.nacionalidade }}</p>
      </div>
    </div>
    <div>
      <p class="icon-prof">
        <i class="pi pi-briefcase"></i>
      </p>
      <div class="descriction-prof">
        <span>Tipo de Bolsa</span>
        <p>Externa</p>
      </div>
    </div>
    <div>
      <p class="icon-prof">
        <i class="pi pi-building"></i>
      </p>
      <div class="descriction-prof">
        <span>Instituição</span>
        <p>Olualinet</p>
      </div>
    </div>
    <div>
      <p class="icon-prof">
        <i class="pi pi-clock"></i>
      </p>
      <div class="descriction-prof">
        <span>Duração</span>
        <p>5 anos</p>
      </div>
    </div>
    <div>
      <p class="icon-prof">
        <i class="pi pi-globe"></i>
      </p>
      <div class="descriction-prof">
        <span>País</span>
        <p>Estados Unidos</p>
      </div>
    </div>
  </div>

  <h3>Sobre o profissional</h3>
  <p>Sem dados</p>

  <div class="inst-learn">

    <h3>Instituição de Ensino</h3>

    <p-panel header="Web Developer - Universidade Católica de Angola" toggleable>
      <p>Em curso</p>
      <span>2019-2024</span>
    </p-panel>
    <p-panel header="Engineer Technician - Universidade Agostinho Neto" toggleable>
      <p>Finalizado</p>
      <span>2017-2022</span>
    </p-panel>
    <p-panel header="English Course - Universidade Técnica de Angola" toggleable>
      <p>Finalizado</p>
      <span>2017-2023</span>
    </p-panel>

  </div>

  <div class="competetion">
    <h3>Competências</h3>
    <div>

      <p-chip label="Eletricidade"></p-chip>
      <p-chip label="Soldadura"></p-chip>
      <p-chip label="Engenharia mecânica"></p-chip>
      <p-chip label="Engenharia"></p-chip>

    </div>
  </div>

  <p-button label="Fechar visualização" (click)="visibleDetails = false" class="p-button-secondary"></p-button>
</p-drawer>-->